import { KnownDeliveryDtoDeliveryType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { InboundDryCleaning } from '../../../ui/components/pure/icons/InboundDryCleaning.icon';
import { InboundMail } from '../../../ui/components/pure/icons/InboundMail.icon';
import { InboundParcel } from '../../../ui/components/pure/icons/InboundParcel.icon';
import { LockerpointOrder } from '../../../ui/components/pure/icons/LockerpointOrder.icon';
import { Order } from '../../../ui/components/pure/icons/Order.icon';
import { OutboundDryCleaning } from '../../../ui/components/pure/icons/OutboundDryCleaning.icon';
import { OutboundMail } from '../../../ui/components/pure/icons/OutboundMail.icon';
import { PeerToPeer } from '../../../ui/components/pure/icons/PeerToPeer.icon';
import { SVGIconComponent } from '../../../ui/components/pure/icons/types';

export const deliveryTypeToIconMap: Record<KnownDeliveryDtoDeliveryType, SVGIconComponent> = {
  'inbound-dry-cleaning': InboundDryCleaning,
  'outbound-dry-cleaning': OutboundDryCleaning,
  'inbound-mail': InboundMail,
  'inbound-parcel': InboundParcel,
  'outbound-mail': OutboundMail,
  'peer-to-peer': PeerToPeer,
  'retail-order': Order,
  'lockerpoint-order': LockerpointOrder
};
